import { QueryClient } from "@tanstack/react-query";

let queryClient: QueryClient | undefined;

export const getQueryClient = (): QueryClient => {
	queryClient ??= new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 1000 * 60 * 5, // 5 minutes
				gcTime: 1000 * 60 * 30, // 30 minutes
				retry: (failureCount, error) => {
					// Only retry transient MSAL token-acquisition failures that bubble
					// up from the `beforeRequest` hook. HTTPErrors from the API are
					// already converted to ApiResult by `apiCall` and never throw
					// here, so we deliberately do NOT retry on HTTP status text.
					if (!(error instanceof Error)) {
						return false;
					}
					const msg = error.message;
					const isAuthRetryable =
						msg.includes("token_refresh_required") ||
						msg.includes("must be refreshed") ||
						/InteractionRequiredAuthError/i.test(msg);
					return isAuthRetryable && failureCount < 2;
				},
				retryDelay: (attemptIndex) =>
					Math.min(1000 * 2 ** attemptIndex, 30_000),
				refetchOnWindowFocus: false,
				// Do not auto-refetch on `online` — when AFD/WAF blocks a request the
				// browser briefly thinks the connection dropped, then `online` fires
				// and would re-trigger every query, amplifying the failure loop.
				refetchOnReconnect: false,
			},
		},
	});
	return queryClient;
};
